import { NotificationType } from '../../components-dummy';

export const toastExpiryTimesSeconds = {
  [NotificationType.Error]: 30,
  [NotificationType.Success]: 2,
  [NotificationType.Warning]: 30,
  [NotificationType.Info]: 10,
};
